import KeyValuePair from '@/modules/core/support/KeyValuePair'
import moment from 'moment';

/**
 * Transportista
 *
 * Representa a una empresa de transportes
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Carrier {
    public id = 0
    public name = ''
    public createdAt = new Date()
    public updatedAt = new Date()

    constructor (name: string) {
        this.name = name
    }

    public get isNew () {
        return !this.id
    }

    public static convert (data: KeyValuePair): Carrier {
        const carrier = new Carrier(data.name)
        carrier.id = data.id
        carrier.updatedAt = moment.unix(data.updated_at).toDate()
        carrier.createdAt = moment.unix(data.created_at).toDate()

        return carrier
    }

    public serialize () {
        return {
            name: this.name,
        }
    }
}
